import * as Sentry from '@sentry/vue'
import { BRANDED_NETWORK_ERROR, BRANDED_TIMEOUT_ERROR } from '@@/api/helpers/brandedError'
import { shouldDropSentryEvent } from '~/utils/sentryFilter'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()

  if (process.env.NODE_ENV !== 'production') return

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: config.public.sentryDsn,
    environment: config.public.sentryEnv,
    attachStacktrace: false,
    traceLifecycle: 'static',
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: {
        request: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
        response: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
      },
      httpBodies: [],
      urlQueryParams: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
      genAI: { inputs: false, outputs: false },
      databaseQueryData: false,
      queues: false,
      graphQL: { document: false, variables: false },
      frameContextLines: 7,
    },
    ignoreErrors: [
      /.*Fetch.*401.*|.*401.*Fetch.*/i,
      /.*Fetch.*419.*|.*419.*Fetch.*/i,
      /.*Fetch.*no response.*|.*no response.*Fetch.*/i,
      BRANDED_TIMEOUT_ERROR,
      BRANDED_NETWORK_ERROR,
      "Can't find variable: gmo",
    ],
    beforeSend(event, hint) {
      if (shouldDropSentryEvent(event, hint, { apiOrigin: config.public.api.baseUrl })) return null

      const original = hint?.originalException as { rawMessage?: unknown } | undefined
      if (original && typeof original.rawMessage === 'string') {
        event.extra = { ...(event.extra ?? {}), rawMessage: original.rawMessage }
      }
      return event
    },
    integrations: [
      Sentry.browserSessionIntegration({ lifecycle: 'route' }),
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 0.1,
    profileSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
})
